import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Convert various image URL formats to displayable URLs
 * Handles Google Drive share links, Google Photos, and local uploads
 */
export function getImageUrl(url, apiUrl = '') {
  if (!url) return '';
  
  // Convert Google Drive share links to direct image URLs
  // Format: https://drive.google.com/file/d/FILE_ID/view?usp=sharing
  // Or: https://drive.google.com/open?id=FILE_ID
  // Or: https://drive.google.com/uc?export=view&id=FILE_ID
  if (url.includes('drive.google.com')) {
    // Folder URLs (e.g. /drive/folders/FOLDER_ID) are NOT images — skip
    if (url.includes('/drive/folders/')) return '';
    let fileId = null;
    
    // Extract file ID from various Google Drive URL formats
    const fileIdMatch = url.match(/\/d\/([a-zA-Z0-9_-]+)/);
    if (fileIdMatch) {
      fileId = fileIdMatch[1];
    } else {
      const idMatch = url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
      if (idMatch) {
        fileId = idMatch[1];
      }
    }
    
    if (fileId) {
      // Use Google's thumbnail API for reliable image display
      return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
    }
    // Unrecognized Drive URL — return empty so the <img> hides (via onError)
    return '';
  }
  
  // Convert Google Photos/Lh3 links if needed
  if (url.includes('lh3.googleusercontent.com') && !url.includes('=')) {
    return `${url}=w1000`;
  }
  
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/uploads/') && apiUrl) return `${apiUrl}${url}`;
  return url;
}
